import smoothscroll from 'smoothscroll-polyfill';


export function search() {

	const searchForm = document.getElementById('search-bar-form');
	const searchbar = document.querySelector('.search-bar');
	const searchBarClose = document.querySelector('#close-search');
	const searchBarSubmit = document.querySelector('#search-bar-submit');
	const searchField = document.getElementById('search');
	const predictionsEl = searchbar.querySelector('.js-prediction-content');
	const suggestedCollectionsTitle = document.getElementById('suggestedCollectionsTitle').value
	const suggestedProductsTitle = document.getElementById('suggestedProductsTitle').value

	const isHomePage = searchForm.classList.contains('js-search-bar-home');

	const defaultPredictions = predictionsEl.innerHTML;
	let n = 0;

	let swapping = false;


	// kick off the polyfill!
	smoothscroll.polyfill();

	searchField.addEventListener('focus', openSearchField, true);

	searchField.addEventListener('keyup', (e) => {

			if (e.target.value.length < 1) {
				resetPredictions();
			}

			if (e.target.value.length < 3) {
				return
			}

			predictiveQuery(e.target.value);

	})

	function openSearchField(e) {

		searchbar.classList.add('is-open');
		document.querySelector('#site-header').scrollIntoView({ 
			behavior: 'smooth' 
		});
		searchBarClose.addEventListener('click', closeSearchField, true);
		document.addEventListener('click', closeSearchField, true);
		document.addEventListener('focus', closeSearchField, true);
		document.addEventListener('keyup', handleEscape, true);
	}

	function closeSearchField(e) {

		if (e.target !== searchBarClose && searchbar.contains(e.target) && e.which !== 27) {
			return
		}

		searchbar.classList.remove('is-open');
		document.documentElement.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth'
		})
		searchBarClose.removeEventListener('click', closeSearchField, true);
		document.removeEventListener('click', closeSearchField, true);
		document.removeEventListener('focus', closeSearchField, true);
		document.removeEventListener('keyup', handleEscape, true);
		searchBarSubmit.focus();
	}

	function handleEscape(e) {
		if (e.which === 27) {
			closeSearchField(e);
		}
		return
		
	}

	function resetPredictions() {

		predictionsEl.innerHTML = defaultPredictions;

	}

	function predictiveQuery(query) {
		
		fetch(`/search/suggest.json?q=${query}&resources[type]=collection,product&resources[limit]=10&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title`)
		
		.then(response => response.json())
		
		.then(suggestions => {

			if (suggestions.status) {
				console.error(json.status, json.message, json.description);
				return
			}
			
			const collections = suggestions.resources.results.collections;
			const products = suggestions.resources.results.products;
			
			const collectionSuggestions = collections.map((collection)=> {
				return `<a href="${collection.url}" class="search-bar__suggestion" tabindex="-1">${ collection.title }</a>`
			})

			const productSuggestions = products.map((product)=> {
				return `<a href="${product.url}" class="search-bar__suggestion" tabindex="-1">${ product.title }</a>`
			})


			return `
			<div>
			<div class="stack stack--xs">
			<h2 class="h">${suggestedCollectionsTitle}</h2>
			${ collectionSuggestions.join('') }
			</div>
			</div>
			<div>
			<div class="stack stack--xs">
			<h2 class="h">${suggestedProductsTitle}</h2>
			${ productSuggestions.join('') }
			</div>
			</div>
			`

		})

		.then(html => {

			predictionsEl.innerHTML = html;
			window.addGaEvents();
		
		})

	}

}